import { Injectable } from '@angular/core';

import { IDateParser } from './IDateParser';
import { IDateParserOptions } from './IDateParserOptions';

import { LegacyDateParserService } from './legacyDateParser.service';
import { ShortDateParserService } from './shortDateParser.service';


@Injectable()
export class DateParserService implements IDateParser {
    private parsers: IDateParser[];

    constructor(
        shortParser: ShortDateParserService,
        legacyParser: LegacyDateParserService
    ) {
        this.parsers = [
            // Uses angular locales to parse dates in format 17mar20 or 17mar
            shortParser,
            // Legacy date parser
            legacyParser,
        ];
    }

    public parse(text: string, options: IDateParserOptions = {}): Date {
        return this.parsers.reduce((result: Date, parser: IDateParser): Date => {
            if (result) {
                return result;
            }

            return parseOne(text, parser, options);
        }, null);
    }
}

function parseOne(text: string, parser: IDateParser, options: IDateParserOptions): Date {
    const parsed: Date = parser.parse(text, options);

    const increment: number = options.yearsIncrement ? Math.abs(options.yearsIncrement) : 1;

    while (parsed && options.max && parsed > options.max) {
        parsed.setFullYear(parsed.getFullYear() - increment);
    }

    while (parsed && options.min && parsed < options.min) {
        parsed.setFullYear(parsed.getFullYear() + increment);
    }

    return parsed;
}